/*
 * @Author: Wei Guojun 
 * @Date: 2021-05-31 11:06:58 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-03-08 10:11:24
 */

<template>
<div>
  <ul class="menu">
    <li v-for="(item,index) in menuList" :key="index" :class="{'active':menu_index===index}" @click="menu_index=index">{{item.label}}</li>
  </ul>
  <receive v-if="menu_index == 0"></receive>
  <send v-else></send>
</div>  
</template>
<script>
import receive from '@/components/receiveMenu';
import send from '@/components/sendMenu';
export default {
    name:'addressMenu',
    data(){
        return{
            menuList:[
                {label:'收件人信息',value:0},
                {label:'寄件人信息',value:1}
            ],
            menu_index:0,    
        }
    },
    components:{
        receive,send
    },
    methods:{

    }
}
</script>
<style lang="stylus" scoped>
.menu{
     display flex;
     background-color #f5f5f5; 
     li{
        height: 40px;
        line-height: 40px;
        margin-left: 20px;
        cursor: pointer;
        position: relative;
        margin-right: 20px;     
        font-size 14px;
        font-weight 700;    
        color #737373;
        &::after {
            position: absolute;
            background: #ffffff;
            content: '';
            left: 50%;
            bottom: 0;
            height: 2px;
            width: 0;
        }
     }
     .active{
        transition: all 0.3s;
        color: #1c8bf6;
        position: relative;   
        &::after {
            transition: all 0.3s;
            background: #1C8BF6;
            width: 100%;
            left: 0;
        }
    }
} 
</style>